<template>
  <div class="background">
    <div class="left" @click="leftClick()">前一天</div>
    <div class="right" @click="rightClick()">后一天</div>
    <div id="main2"> </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts';

  export default {
    name: 'Bar',
    data () {
      return {
        baseUrl: 'http://goc6.com',
        fromTime: new Date(new Date().toLocaleDateString()).getTime(),
        score : 100
      }
    },
    mounted () {
      this.inits();
    },
    methods: {
      leftClick () {
        this.fromTime = this.fromTime - 24*3600*1000;
        this.inits ();
      },
      rightClick () {
        this.fromTime = this.fromTime + 24*3600*1000;
        this.inits ();
      },
      inits (){
        let fromTime = this.fromTime;
        let toTime = fromTime+24*3600*1000;
        const url = this.baseUrl + "/front/time/bar?startTime="+fromTime+"&endTime="+toTime+"&player="+localStorage.getItem("player");
        let that = this;
        this.$axios.get(url, {
        }).then(function (response) {
          //that.score = response.data.score;
          //that.initBar(response.data.timingList || [], fromTime);
          that.initBar(response.data || []);
        })
      },
      initBar (datas) {
        var fromDate = new Date(this.fromTime);
        var a = datas[0]>datas[1] ? datas[0]:datas[1];
        a = a>datas[2] ? a:datas[2];
        var myChart = echarts.init(document.getElementById('main2'));
        var option;
        option = {
          title: [
            {
              text: fromDate.getFullYear()+"-"+(fromDate.getMonth()+1)+"-"+fromDate.getDate(),
              left: 'center'
            }
          ],
          polar: {
            radius: [30, '80%']
          },
          angleAxis: {
            max: 24,//a+1,
            startAngle: 180
          },
          radiusAxis: {
            type: 'category',
            data: ['时间黑洞','红色', '绿色', '蓝色']
          },
          tooltip: {},
          series: {
            type: 'bar',
            itemStyle: {
              normal: {
                color: function(params) {
                  var colorList = ["black", "#bd6d6c", "#72b362", "#7b9ce1"];
                  return colorList[params.dataIndex]
                }
              }
            },
            data: [(24-datas[2]-datas[1]-datas[0]).toFixed(2),
              datas[2].toFixed(2),datas[1].toFixed(2),datas[0].toFixed(2)],
            coordinateSystem: 'polar',
            label: {
              show: true,
              position: 'middle',
              formatter: '{b}: {c}'
            }
          }
        };
        option && myChart.setOption(option);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  html, body { height: 100%; width: 100%;Font-size: 25%}
  .background{
    /*background-image: url("https://t7.baidu.com/it/u=1297102096,3476971300&fm=193&f=GIF");*/
    height: 100%;
    width: 100%;
    background-size: cover;
    position: absolute;
  }

  /*{ "position": "absolute", "width":"100%", "height":"100%", "background-size": "100% 100%", "background-repeat": "no-repeat", "background-image": "url('http://4et.oss-cn-beijing.aliyuncs.com/4et/item/61/bg.png')" }
*/
  #main2{
    position: absolute;
    width: 100%;
    height: 80%;
    top: 20%;
    color: rgb(61, 50, 39);
    font-size: 3rem;
    font-weight: bold;
    text-align: center;
  }
  .left {
    position: absolute;
    width: 30%;
    top: 10%;
    left: 20%;
    color: rgb(61, 50, 39);
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
    box-shadow: 0 5px 7px -1px rgba(51, 51, 51, 0.23);
  }
  .right {
    position: absolute;
    width: 30%;
    top: 10%;
    left: 50%;
    color: rgb(61, 50, 39);
    font-size: 2rem;
    font-weight: bold;
    text-align: center;
    box-shadow: 0 5px 7px -1px rgba(51, 51, 51, 0.23);
  }
</style>



// WEBPACK FOOTER //
// src/components/game/Bar.vue